import React, {useCallback, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import '../../style/calendar.css'
import { getDataRetails, editDataRetails } from '../../services/ConfigRetails';
// import { getClientReservations } from '../services/ConfigReservations';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { UserAuth } from "../../context/AuthContext";
import ModalC from "../modal";
import FormConfig from "../bookingTable/retails/formConfig";
import { useParams } from 'react-router-dom';
import Loading from '../loading';
import Button from '../button'; 

const now = new Date();
const localizer = momentLocalizer(moment);

function MyCalendar({ clients }){

  const [myEvents, setEvents] = useState([]);
  const [dataR, setDataR] = useState({ rows: [] });
  const [pending, setPending] = useState(true);
  const [pendingReser, setPendingReser] = useState(true);
  const [modalR, setModalR] = useState(false);
  const [titleModal, setTitleModal] = useState('');
  const [edit, setEdit] = useState(null);
  const { user } = UserAuth();
  const [ reservationData, setReservationData ] = useState({rows: []});
  let { tap } = useParams();

  useEffect(() => {
    if (user != null) {
      getDataRetails(setDataR, setPending);
    }
  }, [user]);


  useEffect(() => {
    if (dataR?.rows?.length !== 0) {
      setEvents([]);
      // if(tap?.length > 1){
      //   prepareActivites(reservationData.rows);
      // }else{
        prepareActivites(dataR?.rows);
      // }
    }
  }, [dataR]);

  const prepareActivites = (data) => {
    data.forEach(element => {
      if(element?.refund && element?.balance === 0){

      }else{
        if(element?.retail){
          for (let i = 0; element?.retail?.length > i; i++) {
            if(element?.retail?.[i] !== ""){
              let event  = ({
                id: element.id,
                title: element?.retail?.[i]?.label + " " +element?.startTime + "-" + element?.endTime,
                start: new Date(element?.startDate+"T"+element?.startTime),
                end: new Date(element?.endDate+"T"+element?.endTime),
                status: 'Retails',
                color: element?.retail?.[i]?.value,
                retail: element
              });
              setEvents((prev) => [...prev, event]);
            }
          }
        }
      }
    });
  }

  const action = (data) => {
    if (edit) {
      if(data?.retail){
        editDataRetails(data, true);
        setModalR(false);
      }
    } 
    setTimeout(() => {
      getDataRetails(setDataR, setPending);
    }, 500);
  }

  // No delete, is import for future
  const handleSelectSlot = useCallback(
    ({ start, end }) => {
      const title = window.prompt('New Event Name')
      if (title) {
        setEvents((prev) => [...prev, { start, end, title }])
      }
    },
    [setEvents]
  )

  const handleSelectEvent = useCallback(
    (event) => {
      if(event?.status === 'Retails'){
        setModalR(true); 
        setEdit(event?.retail);
        setTitleModal('Edit retail');
      }
    },
    []
  )

  const eventPropGetter = useCallback(
    (event) => {

      let backgroundColor = event?.color;// ? "#173d38" : "green";
      return { style: { backgroundColor } }
      
    },[]
  )

  return (
    <>
    <div className="App calendar">
      { tap?.length > 1 ? (
          !pendingReser ? (
            reservationData?.rows?.length > 1? (
              <>
              <Calendar
              defaultDate={ moment(dataR?.rows?.[0]?.startDate, 'YYYY-MM-DD') }
              defaultView={"month"}
              localizer={localizer}
              resizable
              style={{ height: "100vh" }}
              eventPropGetter={eventPropGetter}
              events={myEvents}
              onSelectEvent={handleSelectEvent}
              //onSelectSlot={handleSelectSlot}
              selectable
            />
            </>
            ) : (
              <>
              <Calendar
                defaultDate={ moment().toDate() }
                defaultView={"month"}
                localizer={localizer}
                resizable
                style={{ height: "100vh" }}
                eventPropGetter={eventPropGetter}
                events={myEvents}
                onSelectEvent={handleSelectEvent}
                //onSelectSlot={handleSelectSlot}d
                selectable
              />
              </>
            )

          ) : ( 
            <div className='d-flex justify-content-center'>
              <Loading></Loading>
            </div>
          )
      ) : (

          pending ? (
              <div className='d-flex justify-content-center'>
                <Loading></Loading>
              </div>
          ) : (
            <>

            <Calendar
                defaultDate={ moment().toDate() }
                defaultView={"month"}
                localizer={localizer}
                resizable
                style={{ height: "100vh" }}
                eventPropGetter={eventPropGetter}
                events={myEvents}
                onSelectEvent={handleSelectEvent}
                //onSelectSlot={handleSelectSlot}d
                selectable
              />
            </>
          )
          
      ) }

      <ModalC
        show={modalR}
        onHide={() => setModalR(false)}
        changeSize={true}> 
        <FormConfig title={titleModal} lastData={edit} textButton={titleModal} action={action} setModal={setModalR} clients={clients}></FormConfig>
      </ModalC> 

    </div>
    </>
  );
  
}

export default MyCalendar;